"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StandaloneCheckbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _internalTypography = require("../../internal/internal-typography");
var _theme = _interopRequireDefault(require("./theme"));
var _grid = require("../../layouts/grid");
var _constants = require("../../utils/constants");
var _stack = require("../../layouts/stack");
var _excluded = ["disabled", "label", "helperText", "error"],
  _excluded2 = ["onChange", "error"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Checkbox = function Checkbox(props) {
  var disabled = props.disabled,
    label = props.label,
    helperText = props.helperText,
    error = props.error,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var HelperTextComponent = !error ? _internalTypography.HelperText : _internalTypography.DangerHelperText;
  return /*#__PURE__*/React.createElement(StyledLabel, (0, _extends2["default"])({
    disabled: disabled
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(StandaloneCheckbox, (0, _extends2["default"])({
    error: error,
    disabled: disabled
  }, rest))), /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(_stack.Stack, {
    spacing: 0
  }, /*#__PURE__*/React.createElement(React.Fragment, null, label), helperText && /*#__PURE__*/React.createElement(HelperTextComponent, null, helperText)))));
};
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  'data-provides': 'checkbox'
};

/**
 * This checkbox is not documented in the storybook because it should not be
 * used by consumers directly. Instead it should be used as part of other
 * seedling components that take into account accessibility.
 */
var StandaloneCheckbox = function StandaloneCheckbox(props) {
  var onChange = props.onChange,
    error = props.error,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var wrappingOnChange;
  if (onChange) {
    wrappingOnChange = function wrappingOnChange(e) {
      onChange(e.currentTarget.checked, e);
    };
  }
  return /*#__PURE__*/React.createElement(CheckboxWrapper, {
    $error: error
  }, /*#__PURE__*/React.createElement("input", (0, _extends2["default"])({
    type: "checkbox"
  }, rest, {
    onChange: wrappingOnChange
  })), /*#__PURE__*/React.createElement(VisualCheckbox, null));
};
exports.StandaloneCheckbox = StandaloneCheckbox;
StandaloneCheckbox.defaultProps = {
  disabled: false
};
StandaloneCheckbox.displayName = 'StandaloneCheckbox';
var VisualCheckbox = function VisualCheckbox() {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Checkmark, null));
};
var StyledLabel = (0, _styledComponents["default"])(_internalTypography.InputOption).withConfig({
  displayName: "checkbox__StyledLabel"
})(["cursor:pointer;", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled && "\n  cursor: not-allowed;\n  color: ".concat(_theme["default"].disabled.labelColor, ";\n  ");
});
var Checkmark = function Checkmark() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "9",
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25119 8.5416C4.12184 8.54174 3.99765 8.49086 3.90559 8.4L0.419193 4.976C0.370197 4.93135 0.330711 4.87729 0.303098 4.81703C0.275485 4.75677 0.260312 4.69156 0.258488 4.6253C0.256663 4.55904 0.268224 4.49309 0.292479 4.4314C0.316734 4.36972 0.353185 4.31356 0.399649 4.26628C0.446114 4.21901 0.501638 4.1816 0.562898 4.15629C0.624158 4.13097 0.689895 4.11828 0.756176 4.11896C0.822457 4.11964 0.887919 4.13369 0.948645 4.16026C1.00937 4.18683 1.06411 4.22538 1.10959 4.2736L3.96479 7.0736C4.03956 7.14689 4.14009 7.18794 4.24479 7.18794C4.34949 7.18794 4.45002 7.14689 4.52479 7.0736L10.9504 0.639997C11.0433 0.550349 11.1676 0.500725 11.2967 0.501795C11.4258 0.502864 11.5493 0.554541 11.6407 0.645715C11.7321 0.73689 11.784 0.860283 11.7854 0.989364C11.7868 1.11845 11.7374 1.24291 11.648 1.336L4.59919 8.4C4.55339 8.44539 4.49907 8.48127 4.43934 8.50557C4.37961 8.52987 4.31567 8.54212 4.25119 8.5416Z",
    strokeWidth: "0.5"
  }));
};
var CheckboxWrapper = _styledComponents["default"].span.withConfig({
  displayName: "checkbox__CheckboxWrapper"
})(["input{appearance:none;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;}span{background-color:", ";display:inline-block;position:relative;height:1.125rem;width:1.125rem;border:1px solid ", ";border-radius:5px;box-sizing:border-box;top:0.1875rem;left:0;svg{fill:", ";stroke:", ";opacity:0;position:absolute;top:0.2125rem;left:0.125rem;}}input:checked + span > svg{opacity:1;}input:focus + span::before{content:'';position:absolute;inset:-4px;border:2px solid rgb(0,95,204);border-radius:6px;opacity:1;pointer-events:none;}input:focus + span::after{content:'';position:absolute;inset:-5px;border:1px solid white;border-radius:6px;opacity:1;pointer-events:none;}input:hover + span{border-color:", ";> svg path{fill:", ";stroke:", ";}}input:active + span{border-color:", ";> svg path{fill:", ";stroke:", ";}}input:disabled + span{border-color:", ";cursor:not-allowed;> svg path{fill:", ";stroke:", ";}}"], _theme["default"].backgroundColor, function (props) {
  return props.$error ? _theme["default"].error.inputColor : _theme["default"]["default"].inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.inputColor : _theme["default"]["default"].inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.inputColor : _theme["default"]["default"].inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.hover.inputColor : _theme["default"]["default"].hover.inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.hover.inputColor : _theme["default"]["default"].hover.inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.hover.inputColor : _theme["default"]["default"].hover.inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.inputColor : _theme["default"]["default"].inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.inputColor : _theme["default"]["default"].inputColor;
}, function (props) {
  return props.$error ? _theme["default"].error.inputColor : _theme["default"]["default"].inputColor;
}, _theme["default"].disabled.inputColor, _theme["default"].disabled.inputColor, _theme["default"].disabled.inputColor);
var _default = Checkbox;
exports["default"] = _default;